
import ResultEvents from "./resultItems/ResultEvents.vue";
import ResultFlavours from "./resultItems/ResultFlavours.vue";
import ResultNews from "./resultItems/ResultNews.vue";
import ResultRecipes from "./resultItems/ResultRecipes.vue";
import ResultInterstitialCTA from "./resultItems/ResultInterstitialCTA.vue";

import { defineComponent, PropType } from "vue";
import {
  InterstitialCta,
  ISiteSearchResultItem
} from "../clients/search/src/models";

export default defineComponent({
  components: {
    ResultEvents,
    ResultFlavours,
    ResultNews,
    ResultRecipes,
    ResultInterstitialCTA
  },
  props: {
    result: {
      type: Object as PropType<ISiteSearchResultItem | InterstitialCta>,
      required: true
    },
    resultType: {
      type: String,
      required: true
    }
  },
  computed: {
    isSearchResultItem() {
      return "id" in this.result && "pageTitle" in this.result;
    }
  }
});
